module.exports = __webpack_public_path__ + "html/pricing.component.html";